var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16/man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 4C8.75 3.58579 9.08579 3.25 9.5 3.25H11.75C12.3023 3.25 12.75 3.69772 12.75 4.25V6.5C12.75 6.91421 12.4142 7.25 12 7.25C11.5858 7.25 11.25 6.91421 11.25 6.5V5.81066L9.62841 7.43225C10.0787 8.11356 10.2957 8.92571 10.242 9.74544C10.1824 10.6532 9.79492 11.5084 9.15165 12.1516C8.50838 12.7949 7.65321 13.1824 6.74544 13.242C5.83767 13.3015 4.93921 13.029 4.21743 12.4753C3.49565 11.9216 2.99977 11.1243 2.82217 10.2321C2.68967 9.56651 2.74106 8.88192 2.96446 8.25001C3.10253 7.85948 3.53104 7.65482 3.92157 7.79289C4.31209 7.93096 4.51675 8.35947 4.37868 8.74999C4.24462 9.12919 4.21381 9.53994 4.2933 9.93927C4.39987 10.4746 4.69739 10.9529 5.13046 11.2852C5.56353 11.6174 6.10261 11.7809 6.64727 11.7452C7.19193 11.7094 7.70503 11.4769 8.09099 11.091C8.47695 10.705 8.70945 10.1919 8.74517 9.64726C8.7809 9.1026 8.61741 8.56353 8.28517 8.13046C7.95294 7.69739 7.4746 7.39987 6.93927 7.2933C6.53994 7.21381 6.12919 7.24462 5.74999 7.37868C5.35947 7.51675 4.93096 7.31209 4.79289 6.92157C4.65482 6.53104 4.85948 6.10253 5.25001 5.96446C5.88192 5.74105 6.56651 5.68967 7.23212 5.82217C7.7126 5.91781 8.16555 6.10577 8.56774 6.3716L10.1893 4.75H9.5C9.08579 4.75 8.75 4.41421 8.75 4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.baa961e3.svg";
export { ForwardRef as ReactComponent };